import {useState,useRef,useEffect} from 'react';
import Image from 'next/image';
import Link from 'next/link';
import {answerGoatQuestion} from '../../lib/community/goatSupport';
type Message={role:'you'|'goat';text:string;path?:string;action?:string};
const initial:Message[]=[{role:'goat',text:'Hi! I’m the GOAT. Need a hand with groceries, Community, videos or flyers? Ask me here. If something is broken, I can help you send a support request.'}];
export default function GoatChat({onOpenChange,isMember=false}: {onOpenChange?: (open:boolean)=>void; isMember?:boolean} = {}){
 const [showInvitation,setShowInvitation]=useState(false);
 useEffect(()=>{
   if (isMember) { setShowInvitation(false); return; }
   let seen=false;
   try {
     const key='youdle-goat-invitation-seen-v1';
     seen=window.localStorage.getItem(key)==='1';
     if (!seen) window.localStorage.setItem(key,'1');
   } catch { /* Visitors with blocked storage can still use GOAT. */ }
   if (seen) return;
   setShowInvitation(true);
   const collapse=window.setTimeout(()=>setShowInvitation(false),25000);
   return ()=>window.clearTimeout(collapse);
 },[isMember]);
 const [open,setOpen]=useState(false),[messages,setMessages]=useState<Message[]>(initial),[input,setInput]=useState(''),[report,setReport]=useState(false),[email,setEmail]=useState(''),[detail,setDetail]=useState(''),[sending,setSending]=useState(false),[result,setResult]=useState('');
 const bottom=useRef<HTMLDivElement>(null);
 useEffect(()=>{onOpenChange?.(open)},[open,onOpenChange]);
 useEffect(()=>{if(open)bottom.current?.scrollIntoView({block:'nearest'})},[messages,open,report]);
 function ask(question:string){
  const q=question.trim();if(!q)return;
  const answer=answerGoatQuestion(q);
  setMessages(current=>[...current.slice(-14),{role:'you',text:q},{role:'goat',...answer}]);setInput('');
  if(/\b(?:broken|bug|error|not working|can't|cannot|problem|issue)\b/i.test(q))setReport(true);
 }
 async function submitSupport(e:React.FormEvent){
  e.preventDefault();if(sending)return;
  setSending(true);setResult('');
  try{
   const response=await fetch('/api/community/goat-support',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({contact:email,details:detail})});
   if(!response.ok)throw Error('send_failed');
   setResult('Your issue was sent to the Youdle support team.');setDetail('');setReport(false);
  }catch{setResult('The report did not send. Please try again, or email info@getyoudle.com.');}
  finally{setSending(false);}
 }
 return <div className="v5-goat-chat" aria-label="Youdle GOAT support">
  {open&&<section className="v5-goat-chat-panel" role="dialog" aria-label="Chat with the GOAT">
   <header><Image src="/img/youdle_goat1.svg" alt="The Youdle GOAT" width={45} height={45}/><div><strong>Ask the GOAT</strong><small>Youdle help and support</small></div><button type="button" onClick={()=>setOpen(false)} aria-label="Close GOAT chat">×</button></header>
   <div className="v5-goat-chat-messages" role="log" aria-live="polite">{messages.map((message,index)=>
    <div key={index} className={'v5-goat-bubble '+message.role}>
     <p>{message.text}</p>{message.path&&<Link href={message.path}>{message.action||'Open page'} →</Link>}
    </div>)}
    <div ref={bottom}/>
   </div>
   {!report&&<><div className="v5-goat-suggestions">{['Watch videos','Promote a flyer','My account','Report a problem'].map(q=><button key={q} type="button" onClick={()=>{if(q==='Report a problem')setReport(true);else ask(q)}}>{q}</button>)}</div>
   <form className="v5-goat-chat-input" onSubmit={e=>{e.preventDefault();ask(input)}}><input aria-label="Ask the GOAT a question" value={input} maxLength={500} onChange={e=>setInput(e.target.value)} placeholder="Ask me a question…"/><button disabled={!input.trim()} type="submit">Send</button></form></>}
   {report&&<form className="v5-goat-report" onSubmit={e=>void submitSupport(e)}>
    <strong>Send an issue to Youdle Support</strong>
    <p>I&apos;ll send your report to the team. I can&apos;t change account settings or repair a technical issue from chat.</p>
    <label>Your email<input type="email" value={email} onChange={e=>setEmail(e.target.value)} required maxLength={254} placeholder="you@example.com"/></label>
    <label>What happened?<textarea value={detail} onChange={e=>setDetail(e.target.value)} required minLength={10} maxLength={1500} rows={3} placeholder="Page, device, what happened. No passwords or payment details."/></label>
    <button disabled={sending||detail.trim().length<10||!email.includes('@')} type="submit">{sending?'Sending…':'Send support request'}</button>
    <button className="v5-goat-report-back" type="button" onClick={()=>setReport(false)}>Back to chat</button>
   </form>}
   {result&&<p role="status" className="v5-goat-chat-status">{result}</p>}
   <p className="v5-goat-chat-note">GOAT gives guided answers. Human support follows up on submitted issues.</p>
  </section>}
  <button className={"v5-goat-launcher" + (!open && !showInvitation ? " v5-goat-launcher-collapsed" : "")} type="button" aria-label={open?'Close GOAT chat':'Chat with the GOAT'} aria-expanded={open} onClick={()=>setOpen(v=>!v)}>
   <Image src="/img/youdle_goat1.svg" alt="" width={45} height={45}/><span className={open || showInvitation ? '' : 'sr-only'}>{open?'Close chat':'Chat with the GOAT'}</span>
  </button>
 </div>;
}
